/* eslint-disable radix */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import {
  Button,
  TextField,
  Divider,
  Typography,
  Grid,
  Card,
} from '@material-ui/core';
import Select from 'react-select';
import { makeStyles } from '@material-ui/core/styles';
import { types } from '../../../../helpers/utils';
import { toastSuccess, toastError } from '../../../../redux/actions/alertActions';
import companyServices from '../../../../redux/services/companyServices';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
    padding: '30px 20px 30px 20px',
  },
  header: {
    alignSelf: 'flex-start',
  },
}));

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isSelected ? '#deebff' : 'white',
    color: 'black',
    fontSize: '14px',
  }),
  control: (base, state) => ({
    ...base,
    minHeight: '56px',
    marginTop: '16px',
    fontSize: '16px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
  menu: (provided) => ({ ...provided, zIndex: 98 }),
};

const AdminData = ({ company, setType }) => {
  const [adminData, setAdminData] = useState(false);
  const [form, setForm] = useState({
    denomination: '',
    address: '',
    phone: '',
    siret: '',
    type: '',
    name: '',
    firstname: '',
    contactPhone: '',
    contactMail: '',
    fname: '',
    ffirstname: '',
    fcontactPhone: '',
    fcontactMail: '',
  });
  const [errors, setErrors] = useState({});

  const classes = useStyles();

  useEffect(() => {
    companyServices.getCompanyDataById(company._id)
      .then((res) => {
        setAdminData(res.adminData);
        // setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (adminData !== undefined) {
      const adminDataObj = {
        denomination: adminData.denomination || '',
        address: adminData.address || '',
        phone: adminData.phone || '',
        siret: adminData.siret || '',
        type: { label: adminData.type || '', value: adminData.type || '' },
      };
      if (adminData.billingContact !== undefined) {
        adminDataObj.name = adminData.billingContact.name || '';
        adminDataObj.firstname = adminData.billingContact.firstname || '';
        adminDataObj.contactPhone = adminData.billingContact.phone || '';
        adminDataObj.contactMail = adminData.billingContact.email || '';
      }
      if (adminData.financialContact !== undefined) {
        adminDataObj.fname = adminData.financialContact.name || '';
        adminDataObj.ffirstname = adminData.financialContact.firstname || '';
        adminDataObj.fcontactPhone = adminData.financialContact.phone || '';
        adminDataObj.fcontactMail = adminData.financialContact.email || '';
      }
      setForm(adminDataObj);
    }
  }, [adminData]);

  const handleSiret = (val) => {
    const isnum = /^[0-9]*$/.test(val);
    if (isnum) {
      setForm({ ...form, siret: val });
    }
  };

  const editAdminData = () => {
    const tempErrors = {};
    const formArr = Object.entries(form);
    formArr.forEach((item) => {
      tempErrors[item[0]] = false;
      if (item[1].length === 0) {
        toastError('Valeur(s) manquante(s)');
        tempErrors[item[0]] = true;
      }
      if (item[0] === 'siret' && item[1].length < 14) {
        toastError('SIRET incorrect');
        tempErrors[item[0]] = true;
      }
    });
    setErrors({ ...tempErrors });

    const adminDataObj = {
      denomination: form.denomination,
      address: form.address,
      phone: form.phone,
      type: form.type && form.type.label ? form.type.label : '',
      siret: parseInt(form.siret),
      billingContact: {
        name: form.name,
        firstname: form.firstname,
        address: '',
        phone: form.contactPhone,
        email: form.contactMail,
      },
      financialContact: {
        name: form.fname,
        firstname: form.ffirstname,
        address: '',
        phone: form.fcontactPhone,
        email: form.fcontactMail,
      },
    };
    companyServices.updateCompanyAdminData(company._id, adminDataObj)
      .then(() => {
        if (form.type !== null) {
          setType(form.type.value);
        }
        setErrors({
          type: false,
          denomination: false,
          address: false,
          phone: false,
          siret: false,
        });
        toastSuccess('Données administratives mises à jour.');
      })
      .catch(() => {
        toastError('Problème lors de la mise à jour des données administratives.');
      });
  };

  return (
    <>
      <Container style={{ padding: 0 }}>
        <Card className={classes.root}>
          <Grid container spacing={2}>
            <Grid item md={3}>
              <Select
                value={form.type || ''}
                styles={customStyles}
                error={errors.type}
                options={types}
                placeholder={"Type d'école"}
                onChange={(e) => setForm({ ...form, type: { label: e.label, value: e.value } })}
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Nom de votre établissement"
                value={form.denomination || ''}
                onChange={(e) => setForm({ ...form, denomination: e.target.value })}
                error={errors.denomination}
              />
            </Grid>
            <Grid item md={5}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Adresse de votre établissement"
                value={form.address || ''}
                onChange={(e) => setForm({ ...form, address: e.target.value })}
                error={errors.address}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item md={4}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Numéro de téléphone"
                value={form.phone || ''}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                error={errors.phone}
              />
            </Grid>
            <Grid item md={8}>
              <TextField
                label="Numéro de SIRET"
                variant="outlined"
                margin="normal"
                error={errors.siret}
                value={form.siret || ''}
                helperText={errors.siret ? 'Le SIRET doit contenir 14 chiffres' : ''}
                onChange={(e) => handleSiret(e.target.value)}
                fullWidth
              />
            </Grid>
          </Grid>
          <Divider style={{ margin: '20px', color: '#adadad' }} />
          <Typography
            component="h6"
            variant="h6"
            className={classes.header}
          >
            Contact de facturation
          </Typography>
          <Grid container spacing={2}>
            <Grid item md={6}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Nom"
                value={form.name || ''}
                error={errors.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Prénom"
                value={form.firstname || ''}
                error={errors.firstname}
                onChange={(e) => setForm({ ...form, firstname: e.target.value })}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item md={5}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Numéro de téléphone"
                value={form.contactPhone || ''}
                onChange={(e) => setForm({ ...form, contactPhone: e.target.value })}
                error={errors.contactPhone}
              />
            </Grid>
            <Grid item md={7}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Email"
                value={form.contactMail || ''}
                onChange={(e) => setForm({ ...form, contactMail: e.target.value })}
                error={errors.contactMail}
              />
            </Grid>
          </Grid>
          <Divider style={{ margin: '20px', color: '#adadad' }} />
          <Typography
            component="h6"
            variant="h6"
            className={classes.header}
          >
            Contact financier
          </Typography>
          <Grid container spacing={2}>
            <Grid item md={6}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Nom"
                value={form.fname || ''}
                error={errors.fname}
                onChange={(e) => setForm({ ...form, fname: e.target.value })}
              />
            </Grid>
            <Grid item md={6}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Prénom"
                value={form.ffirstname || ''}
                error={errors.ffirstname}
                onChange={(e) => setForm({ ...form, ffirstname: e.target.value })}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item md={5}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Numéro de téléphone"
                value={form.fcontactPhone || ''}
                onChange={(e) => setForm({ ...form, fcontactPhone: e.target.value })}
                error={errors.fcontactPhone}
              />
            </Grid>
            <Grid item md={7}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Email"
                value={form.fcontactMail || ''}
                onChange={(e) => setForm({ ...form, fcontactMail: e.target.value })}
                error={errors.fcontactMail}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item md={8} />
            <Grid item md={4}>
              <Button
                onClick={() => {
                  editAdminData();
                }}
                style={{ marginTop: '3.3em', padding: '1em 0 1em 0' }}
                variant="contained"
                color="primary"
                fullWidth
              >
                Mettre à jour
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </>
  );
};

AdminData.propTypes = {
  company: PropTypes.object.isRequired,
  setType: PropTypes.func.isRequired,
};

function mapState(state) {
  const { company } = state.company;
  return { company };
}

const connectedAdminData = connect(mapState, null)(AdminData);

export default withRouter(connectedAdminData);
